var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/CloudConfirm.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const CloudConfirm = ({
  color = '#000',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("g", {
    opacity: "0.5",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.56667 5.36033C4.4 3.76033 6.07333 2.66699 8 2.66699C10.4267 2.66699 12.4467 4.39366 12.9 6.69366C14.6333 6.81366 16 8.24032 16 10.0003C16 11.8403 14.5067 13.3337 12.6667 13.3337H4C1.79333 13.3337 0 11.5403 0 9.33366C0 7.27366 1.56 5.57366 3.56667 5.36033ZM5.14 8.78032L6.55333 10.1937C6.81333 10.4537 7.23333 10.4537 7.49333 10.187L10.32 7.36032C10.58 7.10032 10.58 6.68032 10.32 6.42032C10.06 6.16032 9.64 6.16032 9.38 6.42032L7.02 8.78032L6.08 7.84032C5.82 7.58032 5.4 7.58032 5.14 7.84032C4.88 8.10032 4.88 8.52032 5.14 8.78032Z",
      fill: "white"
    })
  })
});